import { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import "../components/button.css";
import Alerts from "../components/Alerts";
import { TextField, FormControl } from "@mui/material";
import { marginBottom, marginTop } from "../App";
import Button from "@mui/material/Button";
import accounting from "../images/accounting.png";
import logo from "../images/logo2.png";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import { fetchUserData } from "../components/auth";
import { apiRequest } from "../components/Config";
import DateComponent from "../components/DateComponent";
import Box from "@mui/material/Box";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import CheckIcon from "@mui/icons-material/Check";

const Login = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [apiResponse, setApiResponse] = useState({});
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(UserDataContext);
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [sent, setSent] = useState(false);

  const ClearApiResponse = () => {
    setShowApiResponse(false);
  };

  const bull = (
    <Box
      component="span"
      sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
    >
      •
    </Box>
  );
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await apiRequest("login", "POST", {
        user: user,
        password: password,
      });
      setUserData(response);

      const id = response.userId;

      if (response.error_msg === 200 && response.rodo === "1") {
        navigate("/files");
      }

      if (response.error_msg === 200 && response.rodo === "0") {
        console.log("navi");
        navigate(`/rodo/${id}`);
      }

      if (response.error_msg === 403) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Brak uprawnień lub niewłaściwe hasło!",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 501) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Konto nieaktywne, zablokowane lub nie istnieje!",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 502) {
        setApiResponse({
          title: "Ostrzeżenie",
          severity: "warning",
          info: "Nie podano nazwy użytkownika.",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 503) {
        setApiResponse({
          title: "Ostrzeżenie",
          severity: "warning",
          info: "Nie podano hasła.",
        });
        setShowApiResponse(true);
      }
    } catch (error) {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Błąd podczas wysyłania danych.",
      });
      setShowApiResponse(true);
      navigate("/nopermission");
    }
  };

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const userDataAnswer = await fetchUserData();
        //console.log("UDA: ", userDataAnswer);
        if (userDataAnswer && userDataAnswer.userId) {
          setUserData(userDataAnswer);
          navigate("/files");
        } else {
          //navigate("/login");
        }
      } catch (error) {
        console.error("Error during user verification:", error);
        //navigate("/login");
      } finally {
        // setLoading(false);
      }
    };
    verifyUser();
  }, [navigate, setUserData]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  };
  return (
    <>
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Container>
        <ThemeProvider theme={theme}>
          <Row>
            <Col>
              <Form onKeyDown={handleKeyDown} autoComplete="off">
                <Row
                  style={{
                    marginBottom,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Col xs="auto">
                    <FormControl>
                      <TextField
                        autoComplete="none"
                        label="Konto"
                        type="text"
                        variant="outlined"
                        value={user || ""}
                        onChange={(e) => {
                          setUser(e.target.value);
                          ClearApiResponse();
                        }}
                        style={{ width: "130px" }}
                        InputLabelProps={{ shrink: true }}
                      />
                    </FormControl>
                  </Col>

                  <Col xs="auto">
                    <FormControl>
                      <TextField
                        label="Hasło"
                        type="password"
                        variant="outlined"
                        value={password || ""}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          ClearApiResponse();
                        }}
                        style={{ width: "130px" }}
                        InputLabelProps={{ shrink: true }}
                      />
                    </FormControl>
                  </Col>
                </Row>
                <Row>
                  <Col xs="auto">
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={handleSubmit}
                      style={{ minWidth: "88px" }}
                    >
                      Zaloguj
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col>
              <h6>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <LocalPhoneIcon color="primary" />
                  &nbsp;&nbsp;&nbsp; +48 505 428 374
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <EmailIcon color="primary" />
                  &nbsp;&nbsp;&nbsp; kontakt@brprior.pl
                </div>
              </h6>
            </Col>
          </Row>
        </ThemeProvider>
        <Row
          style={{
            marginTop,
            marginBottom,
            display: "flex",
            alignItems: "top",
          }}
        >
          <Col>
            <h3> BIURO RACHUNKOWE</h3>
            <h2>
              {" "}
              <span
                style={{
                  color: "#336699", // kolor tekstu
                  border: "1px solid #336699", // ramka w tym samym kolorze
                  padding: "4px 8px",
                  borderRadius: "4px", // opcjonalnie zaokrąglone rogi
                }}
              >
                PRIOR
              </span>{" "}
              &nbsp;&nbsp;&nbsp;
              <img src={logo} alt="logo" style={{ width: "90px" }} />
            </h2>
            <h3>Elektroniczna obsługa faktur</h3>
          </Col>
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <DateComponent />
            <img src={accounting} alt="księgowa" style={{ width: "300px" }} />
          </Col>
        </Row>
        <br />
        <h4>
          <CheckIcon /> Kompleksowa obsługa księgowa dla firm i osób fizycznych
        </h4>
        <h5>[Prowadzenie ksiąg, rozliczenia podatkowe, kadry i płace]</h5>
        <h4>
          <CheckIcon /> Bezpłatna konsultacja na start – zapytaj o ofertę
        </h4>
        <h5>[Szybki kontakt i indywidualna wycena dla nowych klientów]</h5>

        <h4>
          <CheckIcon /> Gwarancja bezpieczeństwa i terminowości
        </h4>
        <h5>
          [ Ubezpieczenie OC biura, pełna poufność danych i aktualna wiedza o
          przepisach]
        </h5>
        <h4>
          <CheckIcon /> Przejrzyste ceny, żadnych ukrytych kosztów
        </h4>
        <h5>[ Jasne warunki współpracy i elastyczny cennik]</h5>
      </Container>
    </>
  );
};

export default Login;
